<template>
    <el-container id="tab">
        <el-main>
            <el-card shadow="never" class="box-card">
                <el-form ref="queryFormRef" :rules="queryRules" :model="queryForm" label-width="10px" :inline="true">
                    <div class="form-box">
                        <el-form-item label=" " prop="warehouse.selected">
                            <select-multiple :is-clear="false" v-bind:select-data="queryForm.warehouse" suffixText="盘点中" :change="warehouseChange"></select-multiple>
                        </el-form-item>
                        <el-form-item label=" " prop="remark.selected">
                            <el-input v-model="queryForm.remark.selected" clearable placeholder="请输入备注"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-box">
                        <el-card shadow="never" class="left-card">
                            <el-radio v-model="radio" @change="radioChange" label="main" class="title">主商品</el-radio>
                            <el-form-item label=" " prop="product.selected" class="form-item-box">
                                <template>
                                    <select-multiple style="width: 240px;" :is-clear="false" :select-data="queryForm.product" v-if="queryForm.warehouse.selected.value" :optionKey="(i) => (i.itemID + i.productionDate)" :change="(val) => { productChange(val, 'mainProduct') }" :isSlot="true">
                                        <template #header>
                                            <li class="el-select-group__title" style="color: #000; font-weight: bold; font-size: 14px;">
                                                <span style="width: 180px;display: inline-block;">商品</span>
                                                <span style="width: 180px;display: inline-block;">规格</span>
                                                <span style="width: 180px;display: inline-block;">可用库存</span>
                                                <span style="width: 100px;display: inline-block;">生产日期</span>
                                            </li>
                                        </template>
                                        <template v-slot:default='slotProps'>
                                            <div style="flex: 1; display: flex; align-items: center;">
                                                <span style="width: 180px;text-wrap: initial;word-wrap:break-word;word-break:break-all;white-space:normal;">{{ slotProps.item.itemName }}</span>
                                                <span style="width: 180px;display: inline-block;overflow: hidden;text-overflow:ellipsis;">{{ slotProps.item.itemSpec }}</span>
                                                <span style="width: 180px;display: inline-block;overflow: hidden;text-overflow:ellipsis;">{{ slotProps.item.availableQtyFormat }}</span>
                                                <span style="width: 100px;display: inline-block;overflow: hidden;text-overflow:ellipsis;">{{ slotProps.item.productionDate }}</span>
                                            </div>
                                        </template>
                                    </select-multiple>
                                    <div v-else style="width: 210px; border-radius: 4px; padding: 0 15px; color: #C0C4CC;border: 1px solid #DCDFE6;" @click="selectClick">请选择商品名称</div>
                                </template>
                                <el-input style="margin-left: 20px; width: 180px;" :placeholder="'库存： ' + (mainProduct.availableQtyFormat ? mainProduct.availableQtyFormat : '')" disabled>
                                </el-input>
                            </el-form-item>
                            <el-form-item label=" " class="form-col">
                                <el-input style="width: 440px;" :placeholder="'转换比： ' + (mainProduct.conversionStr ? mainProduct.conversionStr : '')" disabled>
                                </el-input>
                            </el-form-item>
                            <el-form-item label=" " class="form-col">
                                <el-input style="width: 440px;" :placeholder="'生产日期： ' + (mainProduct.productionDate ? mainProduct.productionDate : '')" disabled>
                                </el-input>
                            </el-form-item>
                            <el-form-item label=" " class="form-item-box" v-if="radio == 'change'">
                                <el-input style="width: 240px;" :placeholder="'折算：' + (mainProduct.accurateQty ? mainProduct.accurateQty : '')" disabled></el-input>
                                <el-input style="width: 180px; margin-left: 20px;" :placeholder="'折算小单位：' + (mainProduct.invQtySrc ? mainProduct.invQtySrc : '')" disabled></el-input>
                            </el-form-item>
                            <el-form-item label=" " prop="billQty.selected" class="form-item-box" v-if="radio == 'main'">
                                <template>
                                    <el-input v-if="queryForm.product.selected.value" v-focus v-model="queryForm.billQty.selected" style="width: 240px;" placeholder="请输入数量" @blur="inputBlur($event, 'mainProduct', 'billQty')" oninput="value=value.match(/\d+\.?\d{0,2}/, '')"></el-input>
                                    <div v-else style="width: 240px; border-radius: 4px; padding: 0 15px; color: #C0C4CC;border: 1px solid #DCDFE6;" @click="selectChange">请输入数量</div>
                                </template>
                                <template>
                                    <el-select v-if="queryForm.product.selected.value" style="width: 180px; margin-left: 20px;" v-model="mainProduct.unitObj" placeholder="请选择单位" value-key="value" automatic-dropdown @change="inputBlur($event, 'mainProduct', 'billQty')">
                                        <el-option v-for="item in mainProduct.unitArr" :key="item.text" :label="item.text" :value="item">
                                        </el-option>
                                    </el-select>
                                    <div v-else style="width: 120px; border-radius: 4px; padding: 0 15px; color: #C0C4CC;border: 1px solid #DCDFE6; margin-left: 20px;" @click="selectChange">请选择单位</div>
                                </template>
                            </el-form-item>
                            <el-form-item label=" " v-if="allowCostPrice" class="form-col">
                                <el-input style="width: 70%; margin-bottom: 22px;" :placeholder="mainProduct.billPrice ? mainProduct.billPrice : '主商品成本价'" disabled></el-input>
                                <el-input style="width: 70%;" :placeholder="mainProduct.TotalAmt ? mainProduct.TotalAmt : '主商品成本总额'" disabled></el-input>
                            </el-form-item>
                        </el-card>
                        <el-card shadow="never" class="left-card" style="margin-left: 20px;">
                            <el-radio v-model="radio" @change="radioChange" label="change" class="title">转换商品</el-radio>
                            <el-form-item label=" " prop="giftProduct.selected" class="form-item-box">
                                <select-multiple v-if="queryForm.warehouse.selected.value" style="width: 240px;" :is-clear="false" :select-data="queryForm.giftProduct" :optionKey="(i) => (i.itemID + i.productionDate)" :change="(val) => { productChange(val, 'changeProduct') }" :isSlot="true">
                                    <template #header>
                                        <li class="el-select-group__title" style="color: #000; font-weight: bold; font-size: 14px;">
                                            <span style="width: 180px;display: inline-block;">商品</span>
                                            <span style="width: 180px;display: inline-block;">规格</span>
                                            <span style="width: 180px;display: inline-block;">可用库存</span>
                                            <span style="width: 100px;display: inline-block;">生产日期</span>
                                        </li>
                                    </template>
                                    <template v-slot:default='slotProps'>
                                        <div style="flex: 1; display: flex; align-items: center;">
                                            <span style="width: 180px;text-wrap: initial;word-wrap:break-word;word-break:break-all;white-space:normal;">{{ slotProps.item.itemName }}</span>
                                            <span style="width: 180px;display: inline-block;overflow: hidden;text-overflow:ellipsis;">{{ slotProps.item.itemSpec }}</span>
                                            <span style="width: 180px;display: inline-block;overflow: hidden;text-overflow:ellipsis;">{{ slotProps.item.availableQtyFormat }}</span>
                                            <span style="width: 100px;display: inline-block;overflow: hidden;text-overflow:ellipsis;">{{ slotProps.item.productionDate }}</span>
                                        </div>
                                    </template>
                                </select-multiple>
                                <div v-else style="width: 210px; border-radius: 4px; padding: 0 15px; color: #C0C4CC;border: 1px solid #DCDFE6;" @click="selectClick">请选择转换商品名称</div>
                                <el-input style="margin-left: 20px; width: 180px;" :placeholder="'库存： ' + (changeProduct.availableQtyFormat ? changeProduct.availableQtyFormat : '')" disabled>
                                </el-input>
                            </el-form-item>
                            <el-form-item label=" " class="form-col">
                                <el-input style="width: 440px;" :placeholder="'转换比： ' + (changeProduct.conversionStr ? changeProduct.conversionStr : '')" disabled>
                                </el-input>
                            </el-form-item>
                            <el-form-item label=" " class="form-col">
                                <!-- <el-input style="width: 440px;" :placeholder="'生产日期： ' + (mainProduct.productionDate ? mainProduct.productionDate : '')" disabled>
                                </el-input> -->
                                <el-date-picker format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" style="width: 440px;" v-model="changeProduct.productionDate" type="date" placeholder="生产日期"></el-date-picker>
                            </el-form-item>
                            <el-form-item label=" " class="form-item-box" v-if="radio == 'main'">
                                <el-input style="width: 240px;" :placeholder="'折算：' + (changeProduct.accurateQty ? changeProduct.accurateQty : '')" disabled></el-input>
                                <el-input style="width: 180px; margin-left: 20px;" :placeholder="'折算小单位：' + (changeProduct.invQtySrc ? changeProduct.invQtySrc : '')" disabled></el-input>
                            </el-form-item>
                            <el-form-item label=" " prop="changeQty.selected" class="form-item-box" v-if="radio == 'change'">
                                <template>
                                    <el-input v-if="queryForm.giftProduct.selected.value" v-focus v-model="queryForm.changeQty.selected" style="width: 240px;" placeholder="请输入数量" @blur="inputBlur($event, 'mainProduct', 'billQty')" oninput="value=value.match(/\d+\.?\d{0,2}/, '')"></el-input>
                                    <div v-else style="width: 240px; border-radius: 4px; padding: 0 15px; color: #C0C4CC;border: 1px solid #DCDFE6;" @click="selectChange(1)">请输入数量</div>
                                </template>
                                <template>
                                    <el-select v-if="queryForm.giftProduct.selected.value" style="width: 180px; margin-left: 20px;" v-model="changeProduct.unitObj" placeholder="请选择单位" value-key="value" automatic-dropdown @change="inputBlur($event, 'changeProduct', 'changeQty')">
                                        <el-option v-for="item in changeProduct.unitArr" :key="item.text" :label="item.text" :value="item">
                                        </el-option>
                                    </el-select>
                                    <div v-else style="width: 120px; border-radius: 4px; padding: 0 15px; color: #C0C4CC;border: 1px solid #DCDFE6; margin-left: 20px;" @click="selectChange(1)">请选择单位</div>
                                </template>
                            </el-form-item>
                            <el-form-item label=" " v-if="allowCostPrice" class="form-col">
                                <el-input style="width: 70%; margin-bottom: 22px;" :placeholder="changeProduct.costPrice ? changeProduct.costPrice : '转换商品成本价'" disabled></el-input>
                                <el-input style="width: 70%;" :placeholder="changeProduct.TotalAmt ? changeProduct.TotalAmt : '转换商品成本总额'" disabled></el-input>
                            </el-form-item>
                        </el-card>
                    </div>
                    <div class="form-box form-bottom">
                        <div v-if="allowCostPrice" class="form-bottom-text">成本差额<span class="text" style="font-size: 20px">{{cut}}</span>元</div>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </div>
                </el-form>
            </el-card>
        </el-main>
    </el-container>
</template>
<script>
import selectProduct from '@/components/common/selectProduct.vue'
export default {
    name: "InvMakeChange",
    components: {
        selectProduct
    },
    data() {
        return {
            queryForm: {
                warehouse: { submitName: 'warehouseID', selected: [], valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseFreezeForAuth.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/dataSearchVue/selectItemEnterDetailList.html', type: 'post', params: { page: 1, size: 5, billType: 'ZCZ', keyWords: '', warehouseID: '' }, text: 'itemName', value: 'itemID', } },
                giftProduct: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择转换商品名称', request: { url: '/Account/dataSearchVue/selectItemEnterDetailList.html', type: 'post', params: { page: 1, size: 5, billType: 'ZCZ', keyWords: '', }, text: 'itemName', value: 'itemID', } },
                billQty: { selected: '' },
                changeQty: { selected: '' },
                remark: { selected: '' },
            },
            queryRules: {
                'warehouse.selected': [
                    { required: true, message: '请选择仓库', trigger: 'blur' }
                ],
                'product.selected': [
                    { required: true, message: '请选择商品', trigger: 'blur' }
                ],
                'giftProduct.selected': [
                    { required: true, message: '请选择商品', trigger: 'blur' }
                ],
                'billQty.selected': [
                    { required: true, message: '请输入数量', trigger: 'blur' }
                ],
                'changeQty.selected': [
                    { required: true, message: '请输入数量', trigger: 'blur' }
                ]
            },
            mainProduct: {},
            changeProduct: {},
            allowCostPrice: false,
            priceArgs: {
                url: "/Account/dataSearchVue/getUserAllowCostPrice.html",
                code: 'isAllocateDisassembly'
            },
            cut: 0,
            radio: 'main'
        }
    },
    directives: {
        focus: {
            inserted: function(el) {
                el.querySelector('input').onfocus = function(e) {
                    e.currentTarget.select()
                }
                el.querySelector('input').focus()
            }
        }
    },
    watch: {
        'queryForm.warehouse.selected'(val) {
            // console.log(val)
            this.queryForm.product.request.params.warehouseID = val.value
            this.queryForm.giftProduct.request.params.warehouseID = val.value
        }
    },
    created() {
        // this.getTableData()
        let unwatch = this.$watch('$store.state.power', (val) => {
            if (val.enterpriseVersion >= 100) {
                this.getPriceShow()
            }
            unwatch()
        })
    },
    methods: {
        async getPriceShow() {
            const { data: res } = await this.$http.post(this.priceArgs.url, this.Qs.stringify(this.priceArgs))
            this.allowCostPrice = res.result == 'Y'
        },
        async getTableData() {
            this.tableLoading = true
            let url = '/Account/itemComposeDefineVue/selectItemComposeList.html'
            let itemName = !this.searchProduct.selected.text ? '' : this.searchProduct.selected.text
            try {
                const { data: res } = await this.$http.post(url, this.Qs.stringify({ keyWords: itemName }))
                this.tableLoading = false
                if (res.code != 'success') return this.$message.error(res.message)
                this.tableData = JSON.parse(res.result)
            } catch (e) {
                // console.log(e)
                this.tableLoading = false
            }
        },
        warehouseChange(val) {
            if (val && this.queryForm.product.selected.value) {
                // this.getTableData(this.queryForm.product.selected.value)
            }
        },
        productChange(val, form) {
            // console.log(val)
            if (val) {
                // this.getTableData(val.seqNo)
                let obj = { ...val }
                let _unitArr = []
                if (obj.salUnitName) _unitArr.push({ value: 'sal', text: obj.salUnitName })
                if (obj.midUnitName) _unitArr.push({ value: 'mid', text: obj.midUnitName })
                if (obj.invUnitName) _unitArr.push({ value: 'inv', text: obj.invUnitName })
                obj.unitArr = _unitArr
                obj.unitObj = _unitArr[0]
                let str1 = '',
                    str2 = ''
                if (obj.salUnitName && obj.invUnitName && obj.salUnitConversion) str1 = '1' + obj.salUnitName + '=' + obj.salUnitConversion + obj.invUnitName
                if (obj.midUnitName && obj.invUnitName && obj.midUnitConversion) str2 = '  1' + obj.midUnitName + '=' + obj.midUnitConversion + obj.invUnitName
                obj.conversionStr = str1 + str2
                if (!this.queryForm.billQty.selected) this.queryForm.billQty.selected = 1
                if (!this.queryForm.changeQty.selected) this.queryForm.changeQty.selected = 1
                obj.billQty = form == 'mainProduct' ? this.queryForm.billQty.selected : this.queryForm.changeQty.selected
                obj.unitName = _unitArr[0].text
                obj.billPrice = Number(Number(obj[_unitArr[0].value + 'CostPrice']).toFixedRoundUp(2))
                obj.conversion = obj[_unitArr[0].value + 'UnitConversion']
                obj.TotalAmt = Number(Number(Number(obj.billPrice) * obj.billQty).toFixedRoundUp(2))
                this[form] = obj
                // console.log(this[form])
                this.changeProductCon()
            }
        },
        selectClick() {
            if (!this.queryForm.warehouse.selected.value) {
                return this.$message({
                    showClose: true,
                    message: '请先选择仓库',
                    type: 'warning'
                })
            }
        },
        // inputChange(val, tag) {
        //     if (val) {
        //         val = val.replace(/\d+\.?\d{0,2}/, '')
        //         this.queryForm[tag].selected = val
        //     }
        // },
        radioChange(val) {
            // console.log(this.changeProduct)
            if (val) {
                this.changeProductCon()
            }
        },
        inputBlur(e, form, tag) {
            // console.log(this[form], form)
            let formObj = this[form]
            if (formObj.unitObj.value && this.queryForm[tag].selected) {
                formObj.unitName = formObj.unitObj.text
                formObj.billQty = this.queryForm[tag].selected
                formObj.billPrice = Number(formObj[formObj.unitObj.value + 'CostPrice'])
                formObj.conversion = formObj[formObj.unitObj.value + 'UnitConversion']
                formObj.TotalAmt = '' + Number(Number(Number(this.queryForm[tag].selected) * Number(formObj.billPrice)).toFixedRoundUp(2))
                this.changeProductCon()
            }
        },
        changeProductCon() {
            let qtyValue = this.queryForm.billQty.selected
            let form = this.mainProduct
            let changeForm = this.changeProduct
            if (this.radio == 'change') {
                qtyValue = this.queryForm.changeQty.selected
                form = this.changeProduct
                changeForm = this.mainProduct
            }
            console.log(this.mainProduct, this.changeProduct)
            if (this.queryForm.product.selected.value && this.queryForm.giftProduct.selected.value && form['unitObj'].value && qtyValue) {
                let num = 0
                // console.log(form['unitObj'])
                if (form['unitObj'].value == 'sal') {
                    num = Number(qtyValue) * Number(form.salUnitConversion)
                } else if (form['unitObj'].value == 'mid') {
                    num = Number(qtyValue) * Number(form.midUnitConversion)
                } else if (form['unitObj'].value == 'inv') {
                    num = Number(qtyValue)
                }
                changeForm.invQtySrc = Number(Number(num).toFixedRoundUp(2)) + changeForm.invUnitName
                changeForm.billQty = num
                changeForm.unitName = changeForm.invUnitName
                changeForm.conversion = changeForm.invUnitConversion
                changeForm.billPrice = changeForm.invCostPrice
                changeForm.accurateQty = this.getAccurateQty(num, changeForm.salUnitConversion, changeForm.midUnitConversion, changeForm.salUnitName, changeForm.midUnitName, changeForm.invUnitName)
                changeForm.costPrice = Number(Number(changeForm.salCostPrice).toFixedRoundUp(2)) + '/' + changeForm.salUnitName + '   ' + (changeForm.midUnitName ? (Number(Number(changeForm.midCostPrice).toFixedRoundUp(2)) + '/' + changeForm.midUnitName) : '') + '  ' + Number(Number(changeForm.invCostPrice).toFixedRoundUp(2)) + '/' + changeForm.invUnitName
                changeForm.TotalAmt = Number(Number(num * Number(changeForm.invCostPrice)).toFixedRoundUp(2))
                if (this.radio == 'change') {
                    this.changeProduct = { ...this.changeProduct, ...form }
                    this.mainProduct = { ...this.mainProduct, ...changeForm }
                } else {
                    this.changeProduct = { ...this.changeProduct, ...changeForm }
                    this.mainProduct = { ...this.mainProduct, ...form }
                }
                this.cut = Number(Number(this.changeProduct.TotalAmt) - Number(this.mainProduct.TotalAmt)).toFixedRoundUp(2)
            }
        },
        getAccurateQty(num, salUnitConversion, midUnitConversion, salUnitName, midUnitName, invUnitName) {
            let str = ''
            if (salUnitConversion == 1) { //大单位=小单位
                str = num + salUnitName
            } else {
                if (midUnitConversion > 1) { //有中单位
                    let salQty = parseInt(num / salUnitConversion) // 大单位数量=小单位数量/大单位转换比 取整
                    let invQty = num % salUnitConversion // 小单位数量=大单位数量*大单位转换比 取余
                    let midQty = parseInt(invQty / midUnitConversion) //中单位数量=小单位数量/中单位转换比 取整
                    invQty = invQty % midUnitConversion // 真正的小单位数量=中单位数量*中单位转换比 取余
                    str = Number(Number(salQty).toFixedRoundUp(2)) + salUnitName + Number(Number(midQty).toFixedRoundUp(2)) + midUnitName + Number(Number(invQty).toFixedRoundUp(2)) + invUnitName
                } else {
                    let salQty = parseInt(num / salUnitConversion) // 大单位数量=小单位数量/大单位转换比 取整
                    let invQty = num % salUnitConversion // 小单位数量=大单位数量*大单位转换比 取余
                    str = Number(Number(salQty).toFixedRoundUp(2)) + salUnitName + Number(Number(invQty).toFixedRoundUp(2)) + invUnitName
                }
            }
            return str
        },
        selectChange(type) {
            let name = this.queryForm.product.selected.value || ''
            if (type == 1) name = this.queryForm.giftProduct.selected.value || ''
            if (!name) {
                return this.$message({
                    showClose: true,
                    message: '请先选择商品',
                    type: 'warning'
                })
            }
        },
        async submit() {
            if (!this.queryForm.warehouse.selected.value) {
                return this.$message({
                    showClose: true,
                    message: '请先选择仓库',
                    type: 'warning'
                })
            }
            if (!this.queryForm.product.selected.value) {
                return this.$message({
                    showClose: true,
                    message: '请先选择主商品',
                    type: 'warning'
                })
            }
            if (!this.queryForm.giftProduct.selected.value) {
                return this.$message({
                    showClose: true,
                    message: '请先选择转换商品',
                    type: 'warning'
                })
            }
            if ((!this.queryForm.billQty.selected && this.radio == 'main') || (!this.queryForm.changeQty.selected && this.radio == 'change')) {
                return this.$message({
                    showClose: true,
                    message: '请先输入数量',
                    type: 'warning'
                })
            }
            let currTab = '',
                title = ''
            if (top.$('#tabspanel .tabs-selected').text()) {
                currTab = top.$('#tabspanel').tabs('getSelected') || ''
                title = top.$('#tabspanel .tabs-selected').text() || ''
            } else {
                title = top.getTabName() || ''
                currTab = top.getTabName() || ''
            }
            let headInfo = {
                outWarehouseID: this.queryForm.warehouse.selected.value,
                outWarehouseName: this.queryForm.warehouse.selected.text,
                inWarehouseID: this.queryForm.warehouse.selected.value,
                inWarehouseName: this.queryForm.warehouse.selected.text,
                remark: this.queryForm.remark.selected
            }
            const loading = this.$loading({
                lock: true,
                text: '提交中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            let url = '/Account/invItemComposeVue/addInvItemTransformVue.html'
            let submitInfo = {
                headInfo: JSON.stringify(headInfo),
                mainItemList: JSON.stringify(this.mainProduct),
                transformItemList: JSON.stringify(this.changeProduct)
            }
            const { data: res } = await this.$http.post(url, this.Qs.stringify(submitInfo))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/invMakeChange`, currTab)
        }
    }
};
</script>
<style lang="less">
.el-select-group__title~.el-select-dropdown__item {
    height: auto !important;
}
</style>

<style scoped lang="less">
#tab {
    .el-main {
        padding: 0;

        .box-card {
            height: calc(100% - 2px);

            /deep/.el-radio__label {
                font-size: 16px;
            }

            /deep/.el-card__body {
                padding: 10px;
                height: calc(100% - 20px);
                overflow: auto;

                .select_multiple {
                    width: 100%;

                    ::v-deep .el-select__tags {
                        max-height: 80px;
                        overflow-y: auto;
                        overflow-x: hidden;
                    }
                }

                /deep/.el-form-item__content {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                /deep/.el-input-number {
                    width: 100%;

                    input {
                        text-align: left;
                    }
                }

                .el-form-item {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }


                .form-box {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;

                    &.form-bottom {
                        // justify-content: flex-start;
                        margin-top: 30px;
                        line-height: 40px;
                        position: relative;
                    }

                    .form-bottom-text {
                        width: 50%;
                        position: absolute;
                        left: 50%;
                        transform: translate(-50%, 0);
                        z-index: 0;
                    }

                    .text {
                        color: #F56C6C;
                        padding: 0 4px;
                        font-size: 14px;
                        font-weight: bolder;
                    }

                    .el-button {
                        z-index: 1;
                        position: relative;
                    }
                }

                .left-card {
                    width: 540px;

                    .title {
                        margin-top: 12px;
                        font-weight: bolder;
                        margin-bottom: 16px;
                        margin-left: 10px;
                        display: block;
                    }

                    .form-item-box {
                        display: flex;
                        align-items: center;

                        .el-form-item__content {
                            display: flex;
                            align-items: center;
                        }
                    }

                    .form-col {
                        display: flex;
                        flex-direction: column;
                        margin-left: 12px;
                        align-items: inherit;

                        .el-form-item__content {
                            display: flex;
                            flex-direction: column;
                            align-items: inherit;
                        }
                    }
                }
            }
        }

        /deep/.el-input.is-disabled {
            background-color: #fff;

            .el-input__inner {
                color: #606266;
            }

            .el-input__inner::-webkit-input-placeholder {
                color: #606266;
            }
        }
    }
}
</style>